import * as tslib_1 from "tslib";
import { Location } from '@angular/common';
import { OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { GlobalDataService } from '@providers/global-data/global-data.service';
import { GlobalFunctionService } from '@providers/global-function/global-function.service';
import { RequestService } from '@providers/request/request.service';
import { RequestV2Service } from '@providers/request-service-v2/request-v2.service';
var QuotationComponent = /** @class */ (function () {
    function QuotationComponent(location, router, activatedRoute, requestService, requestV2Service, globalFunction, globalDataService) {
        var _this = this;
        this.location = location;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.requestService = requestService;
        this.requestV2Service = requestV2Service;
        this.globalFunction = globalFunction;
        this.globalDataService = globalDataService;
        this.isDownload = false;
        this.diameter = 25;
        this.mode = 'indeterminate';
        this.value = 50;
        router.events.subscribe(function () {
            if (location.path() !== '') {
                _this.route = location.path();
            }
            else {
                _this.route = 'Home';
            }
        });
    }
    QuotationComponent.prototype.ngOnInit = function () {
        this.retrieveVersionQuotationData();
    };
    QuotationComponent.prototype.retrieveVersionQuotationData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.activatedRoute.params.subscribe(function (params) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    var versionResult, financial, _a, _b, chaptersResult;
                    return tslib_1.__generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                this.quotationId = params['qid'];
                                this.versionId = params['vid'];
                                return [4 /*yield*/, this.requestV2Service.getVersion(this.versionId)];
                            case 1:
                                versionResult = _c.sent();
                                return [4 /*yield*/, this.requestV2Service.getQuotationVersionFinancial(this.versionId)];
                            case 2:
                                financial = _c.sent();
                                this.globalDataService.financial = financial;
                                _a = this;
                                return [4 /*yield*/, this.requestV2Service.getQuotation(this.quotationId)];
                            case 3:
                                _a.quotation = _c.sent();
                                _b = this;
                                return [4 /*yield*/, this.requestV2Service.getProject(this.quotation.id_project, true)];
                            case 4:
                                _b.project = _c.sent();
                                this.globalDataService.setCurrentProjectId(this.project.id);
                                this.globalDataService.setCurrentProject(this.project);
                                return [4 /*yield*/, this.requestV2Service.getChapters(this.versionId)];
                            case 5:
                                chaptersResult = _c.sent();
                                this.chapters = chaptersResult.items;
                                this.quotationVersion = versionResult;
                                this.quotationNumber = this.versionId;
                                return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    QuotationComponent.prototype.getTva = function () {
        if (this.globalDataService.financial) {
            var totalTVA = this.globalDataService.financial.customer.vat[10]
                + this.globalDataService.financial.customer.vat[20]
                + this.globalDataService.financial.customer.vat[5.5];
            return totalTVA;
        }
        return 10;
    };
    QuotationComponent.prototype.downloadCustomer = function () {
        var _this = this;
        this.isDownload = true;
        this.requestV2Service.downloadQuotationVersion(this.versionId, 'customer', 'pdf', false)
            .then(function (data) {
            _this.downloadFile(data);
            _this.isDownload = false;
        });
    };
    // Create and download file
    QuotationComponent.prototype.downloadFile = function (data) {
        var filename = this.getFileNameFromHttpResponse(data);
        var blob = new Blob([data.body], { type: 'application/pdf' });
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = filename;
        a.click();
    };
    // Extract content-disposition headers value
    QuotationComponent.prototype.getFileNameFromHttpResponse = function (httpResponse) {
        var contentDispositionHeader = httpResponse.headers.get('content-disposition');
        var result = contentDispositionHeader
            .split(';')[1]
            .trim()
            .split('=')[1];
        return result.replace(/"/g, '');
    };
    return QuotationComponent;
}());
export { QuotationComponent };
